import { render, staticRenderFns } from "./receive-status.vue?vue&type=template&id=3572703d&scoped=true&"
import script from "./receive-status.vue?vue&type=script&lang=js&"
export * from "./receive-status.vue?vue&type=script&lang=js&"
import style0 from "./receive-status.vue?vue&type=style&index=0&id=3572703d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572703d",
  null
  
)

export default component.exports